import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

// The parent route mounted `../pages` (barrel), which pulled PathAssociationRouter and its
// react-router-dom tree into the entry chunk. Everything here must stay lazy.
// Shared with preloadInitialRoute, so a cold load fetches both chunks in parallel with the boot gates.
export const importPathAssociationRouter = () => import('../pages/PathAssociationRouter');
export const importPathAssociationPage = () => import('../pages/PathAssociationPage');

const PathAssociationRouter = lazy(importPathAssociationRouter);
const PathAssociationPage = lazy(importPathAssociationPage);
const VehiclePathsPage = lazy(() => import('../pages/VehiclePathsPage'));

const routes = [
  {
    path: Location.PATH_ASSOCIATION,
    team: 'squad-video-xp',
    component: PathAssociationRouter,
    featureFlag: 'enableDriverAssociationPast',
    routes: [
      {
        path: Location.PATH_ASSOCIATION_VEHICLE,
        component: VehiclePathsPage,
        exact: true,
      },
      {
        path: Location.PATH_ASSOCIATION,
        component: PathAssociationPage,
        exact: true,
      },
    ],
  },
];

export default routes;
